// @ts-nocheck
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import {
    chain,
    SetProductInfo as baseSetProductInfo,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/UpdateVariantSelection";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { createFromProduct } from "@store/Modules/client-framework/src/Common/ProductInfo";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetProductInfo = createChainHandler("SetProductInfo", chain, async props => {
    // Only the "createFromProduct" function import has changed.
    if (!props.selectedProductId) {
        return;
    }

    props.productInfo = createFromProduct(getProductState(props.getState(), props.selectedProductId).value!);

    const promise = new Promise<void>(resolve => {
        const { productInfo } = props;
        props.dispatch(
            loadRealTimePricing({
                productPriceParameters: [productInfo!],
                onSuccess: realTimePricing => {
                    const pricing = realTimePricing.realTimePricingResults!.find(
                        o => o.productId === productInfo!.productId,
                    );
                    if (pricing) {
                        productInfo!.pricing = pricing;
                    } else {
                        productInfo!.failedToLoadPricing = true;
                    }
                    resolve();
                },
                onError: () => {
                    productInfo!.failedToLoadPricing = true;
                    resolve();
                },
                onComplete(realTimePricingProps) {
                    if (realTimePricingProps.apiResult) {
                        this.onSuccess?.(realTimePricingProps.apiResult);
                    } else if (realTimePricingProps.error) {
                        this.onError?.(realTimePricingProps.error);
                    }
                },
            }),
        );
    });

    await promise;
});

replaceInChain(chain, baseSetProductInfo, SetProductInfo);
